module.exports = __webpack_public_path__ + "img/truck.7b74d5de.png";